<script lang="ts">
	import { onMount } from "svelte";
	import { useParams, navigate } from "svelte-navigator";
	import Card from "../general/Card.svelte";
	import { get_grocery_list, update_grocery_list } from "../tastummy";
	import type { GroceryList, GroceryListItem } from "../recipes/recipe.types";
	import Popup from "../general/Popup.svelte";

	let list: GroceryList = {
		items: [],
		name: "",
		owner: "",
	};
	let params = useParams();
	onMount(async () => {
		// get list from url
		let r = await get_grocery_list($params.id);
		list = r.data;
	});

	let new_ingredient_name = "";
	let show_popup = false;

	function clear_items() {
		for (const item of list.items) {
			if (item.checked) {
				item.cleared = true;
			}
		}
		list = list;
	}

	function add_ingredient() {
		list.items.push({
			aisle: "",
			checked: false,
			cleared: false,
			name: new_ingredient_name,
			unit: "",
			image: "",
			amount: 0,
		});
		list = list;
		show_popup = false;
		new_ingredient_name = "";
		save_list();
	}

	function save_list() {
		console.log(list);
		update_grocery_list(list)
			.then((r) => {
				navigate("/grocery-list/" + r.data.id);
				list = r.data;
			})
			.catch(() => console.log("Error creating grocery list"));
	}

	function group_by_id(
		ingredients: GroceryListItem[]
	): Map<string, Map<string, GroceryListItem[]>> {
		let grouped = new Map<string, Map<string, GroceryListItem[]>>();
		// turn ingredients into a map of aisle -> ingredient_id -> ingredients
		for (let ingredient of ingredients) {
			// skip if the ingredient is cleared so aisles with no items don't show up
			if (ingredient.cleared) {
				continue;
			}
			if (!grouped.has(ingredient.aisle)) {
				grouped.set(ingredient.aisle, new Map());
			}
			let aisle = grouped.get(ingredient.aisle);
			if (!aisle.has(ingredient.ingredient_id)) {
				aisle.set(ingredient.ingredient_id, []);
			}
			let ingredient_id = aisle.get(ingredient.ingredient_id);
			ingredient_id.push(ingredient);
		}
		return grouped;
	}
</script>

<div class="parent">
	{#each [...group_by_id(list.items)] as [aisle, ingredient_map]}
		<h1>{aisle}</h1>
		{#each [...ingredient_map] as [_, ingredients]}
			{#if !ingredients[0].cleared}
				<Card selected={ingredients[0].checked}>
					<div
						class="recipe-text"
						on:click={() => {
							for (let i = 0; i < ingredients.length; i++) {
								ingredients[i].checked =
									!ingredients[i].checked;
							}
						}}
					>
						<img
							alt={ingredients[0].name}
							class="ingredient-image"
							src={ingredients[0].image}
						/>
						<input
							type="checkbox"
							bind:checked={ingredients[0].checked}
						/>
						{#each ingredients as item (item.id)}
							<p>{item.name} - {item.amount} {item.unit}</p>
							<br />
						{/each}
					</div>
				</Card>
			{/if}
		{/each}
	{/each}
</div>
<br />

<button on:click={clear_items}>Clear Checked</button>
<button on:click={save_list}>Save List</button>
<button on:click={() => (show_popup = true)}>Add Ingredient</button>

<Popup bind:visible={show_popup}>
	<h1>Add Grocery List Item</h1>
	<input
		type="text"
		placeholder="Ingredient"
		bind:value={new_ingredient_name}
		class="add-ingredient-input"
	/>
	<button on:click={add_ingredient}>Add</button>
</Popup>

<style>
	@media (hover: none) {
		/* input {
			display: none;
		} */
	}
	p {
		display: inline-block;
	}
	.parent {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
	}
	h1 {
		grid-column: 1 / -1;
	}
	.ingredient-image {
		width: 50px;
		height: 50px;
		display: block;
		margin: auto;
	}
	.add-ingredient-input {
		background-color: var(--background-2);
	}

	@media (min-width: 640px) {
		.parent {
			grid-template-columns: repeat(3, 1fr);
		}
	}
	@media (min-width: 900px) {
		.parent {
			grid-template-columns: repeat(4, 1fr);
		}
	}
	@media (min-width: 1200px) {
		.parent {
			grid-template-columns: repeat(6, 1fr);
		}
	}
</style>
